import { render, staticRenderFns } from "./CorrelationContent.vue?vue&type=template&id=61467f2c&scoped=true"
import script from "./CorrelationContent.vue?vue&type=script&lang=ts"
export * from "./CorrelationContent.vue?vue&type=script&lang=ts"
import style0 from "./CorrelationContent.vue?vue&type=style&index=0&id=61467f2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61467f2c",
  null
  
)

export default component.exports